import type { EventProperties } from '@segment/analytics-next';

export class Analytics {
  private checkMethodAvailability(name: 'track' | 'page') {
    if (!('renta' in window)) {
      return false;
    }

    if (name === 'track') {
      return typeof window.renta?.track === 'function';
    }

    if (name === 'page') {
      return typeof window.renta?.page === 'function';
    }

    return false;
  }

  track(action: string, properties?: EventProperties) {
    if (this.checkMethodAvailability('track')) {
      try {
        window.renta.track(action, properties ?? {});
      } catch (error) {
        console.error('Error in window.renta.track:', error);
      }
    }
  }

  page(action: string, properties?: EventProperties) {
    if (this.checkMethodAvailability('page')) {
      try {
        window.renta.page(action, properties);
      } catch (error) {
        console.error('Error in window.renta.page:', error);
      }
    }
  }
}
export default Analytics;
